import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TABS = ["orders", "quotes", "pricing", "stories", "previews", "interest", "members", "emails", "content"];

const TAB_LABELS = {
  orders: "Orders",
  quotes: "B2B Quotes",
  pricing: "Pricing & Products",
  previews: "Top Previews",
  interest: "Product Interest",
  members: "Members",
  emails: "Emails",
  content: "Content Preview",
};

export const AdminTabs = ({ tab, onChange, pendingStories }) => (
  <div className="flex gap-3 mb-8 flex-wrap">
    {TABS.map((t) => (
      <button
        key={t}
        onClick={() => onChange(t)}
        data-testid={`admin-tab-${t}`}
        className={`px-5 py-2.5 rounded-full text-xs font-mono uppercase tracking-[0.2em] border transition-colors duration-300 ${tab === t ? "bg-[#F59E0B] text-black border-[#F59E0B]" : "border-[#E7DFD5] text-[#44403C] hover:border-[#F59E0B]"}`}
      >
        {t === "stories" ? `Stories (${pendingStories ?? 0})` : TAB_LABELS[t]}
      </button>
    ))}
  </div>
);

export const AdminHeaderActions = ({ loading, onRefresh }) => {
  const [sending, setSending] = useState(false);
  const sendDigest = async () => {
    setSending(true);
    try {
      const { data: d } = await axios.post(`${API}/admin/jobs/weekly-digest`);
      toast.success(d.email_ok ? "Digest sent to your inbox." : "Digest computed, but the email didn't send.", {
        description: `${d.signups} sign-ups · ${d.purchases} purchases · ${d.grounded_members} grounded · ${d.graduations} graduations (last 7 days)`,
      });
    } catch {
      toast.error("Could not send the digest.");
    } finally {
      setSending(false);
    }
  };
  return (
    <div className="flex flex-wrap gap-3 md:justify-end">
      <button onClick={sendDigest} disabled={sending} className="btn-ember text-sm w-fit disabled:opacity-60" data-testid="admin-send-digest">
        <Mail size={15} className={sending ? "animate-pulse" : ""} /> Send digest now
      </button>
      <button onClick={onRefresh} className="btn-outline text-sm w-fit" data-testid="admin-refresh">
        <RefreshCw size={15} className={loading ? "animate-spin" : ""} /> Refresh
      </button>
    </div>
  );
};
